import React, { PureComponent } from 'react';
import { getTranslate } from 'react-localize-redux';
import { Form, Input } from 'antd';
import { connect } from 'react-redux';

@connect(({ localize }) => ({
  translate: getTranslate(localize)
}))
@Form.create()
export default class AccountVerification extends PureComponent {
  render() {
    const { translate, form } = this.props;
    const { getFieldDecorator } = form;
    const ruleRequired = {
      required: true,
      message: translate('validation.required.default')
    };
    return (
      <Form>
        <Form.Item
          className={'password'}
          label={translate('withdrawal.password')}
        >
          {getFieldDecorator('password', {
            rules: [ruleRequired]
          })(
            <Input
              type={'password'}
              className={'no-border'}
              placeholder={translate('withdrawal.passwordPlaceholder')}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}
